import { NonNullableFormBuilder, Validators } from '@angular/forms';
import { CreateVenueDto, VenuesService } from '@rezevent/api-types';
import { ControlsInterface } from '@rezevent/core';
import { map, startWith, Subject } from 'rxjs';
import { inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class VenueService {
  private _api = inject(VenuesService);

  refresh$ = new Subject<void>();

  delete$(id: string, force: boolean) {
    return this._api.venuesControllerDelete(id, force);
  }

  list$ = this._api.venuesControllerList();

  post$(requestParameters: CreateVenueDto) {
    return this._api.venuesControllerCreate(requestParameters);
  }
}

export class VenueFrom {
  constructor(
    private fb: NonNullableFormBuilder,
    private defaultValue?: CreateVenueDto | null,
  ) {}
  private _ctrls: ControlsInterface<CreateVenueDto> = {
    name: this.fb.control<string>(this.defaultValue?.name ?? '', [Validators.required]),
    description: this.fb.control<string>(this.defaultValue?.description ?? ''),
    capacity: this.fb.control<number>(this.defaultValue?.capacity ?? 0, [
      Validators.required,
      Validators.min(1),
    ]),
  };

  private _fg = this.fb.group(this._ctrls);

  form = {
    fgCtrls: this._ctrls,
    fg: this._fg,
    fgValueChanges$: this._fg.valueChanges.pipe(
      map(() => this._fg.getRawValue() as CreateVenueDto),
    ),
    fgValue$: this._fg.valueChanges.pipe(
      startWith(null),
      map(() => this._fg.getRawValue() as CreateVenueDto),
    ),
  };
}
